// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"DashboardWelcome_iconContainer__7AhDn","welcomeInfo":"DashboardWelcome_welcomeInfo__1mmD8","details":"DashboardWelcome_details__2DBmB"};